$(document).ready(function(){
  
  $('.rptoChooserContainer .content').on('click', function(e){
    
      e.preventDefault();
      
      if(typeof $(this).data('url') != 'undefined')
        window.location = $(this).data('url');      
      
  });
  
  $(window).on('resize', function() {
    
    $('.rptoChooserContainer h2, .rptoChooserContainer h3, .rptoChooserContainer p, .rptoChooserContainer .to-demo-features, .rptoChooserContainer .buttonContainer').css('height','auto');
    
    var windowWidth = window.innerWidth;
    
    if(windowWidth > 991) {
      sameHeigtElement('.rptoChooserContainer h2');
      sameHeigtElement('.rptoChooserContainer h3');
      sameHeigtElement('.rptoChooserContainer p.aboveHeadline');
      sameHeigtElement('.rptoChooserContainer p.discoverMore');
      sameHeigtElement('.rptoChooserContainer p.justText');
      sameHeigtElement('.rptoChooserContainer .to-demo-features');
      sameHeigtElement('.rptoChooserContainer .buttonContainer');
      sameHeigtElement('.rptoChooserContainer .listContainer');
    } else {
      //todo: clear same heights
    }
  });
  
  $(window).trigger('resize');

});

function sameHeigtElement(el) {
  
  $temp = 0;
  
  $(el).each(function(){
    if($(this).height() > $temp) {
      $temp = $(this).height();
    }
  });
  
  $(el).height($temp);
  
}

